<template>
  <div class="app-web-layout">
    <!-- header -->
    <div class="web-header-wrapper">
      <div class="web-wrapper">
        <div class="header-container">
          <div class="logo" @click="goHome" title="回到首页">
            <h1 class="title">盟创金服平台</h1>
          </div>
          <div class="right">
            <span @click="goHome" class="go-home">回到首页</span>
            <span>平台:</span>
            <el-select v-model="tempNo" clearable @change="handleChange" style="margin:10px;" size="small">
              <el-option v-for="(item,index) in dataList" :key="index" :label="item.instName" :value="item.instNo">{{item.instName}}</el-option>
            </el-select>
            <el-dropdown split-button type="primary" @command="handleCommand">
              <span class="el-dropdown-link">
                {{ userInfo.loginName }}
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="1">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
    </div>
    <div class="web-main-wrapper">
      <div class="web-wrapper">
        <aside-menu />
        <div class="web-context">
          <router-view :key="key" />
        </div>
      </div>
    </div>

    <!-- footer -->
    <div class="web-footer-wrapper">
      <div class="web-wrapper">
        <div class="copyright">Copyright 2020 盟创金服 All rights reserved.</div>
      </div>
    </div>
  </div>
</template>

<script>
import AsideMenu from './components/AsideMenu'
import { mapGetters } from 'vuex'

export default {
  name: 'webLayout',
  components: {
    AsideMenu,
  },
  data() {
    return {
      dataList: [],
      tempNo:null
    }
  },
  computed: {
    ...mapGetters(['platformNo','userInfo']),
    key() {
      return this.$route.path
    },
  },
   watch:{
    platformNo(val) {
      if (val) {
         this.tempNo=val
      }
    },
  },
  mounted(){
    this.tempNo=this.platformNo
    this.getList()
  },
  methods: {
    handleCommand(e) {
      if(e == 1) {
        this.logout()
      }
    },
    goHome() {
      this.$router.push(`/`)
    },
    // 退出登录
    logout() {
      this.$store.dispatch('user/logout').then(() => {
        this.$router.push(`/login`)
      })
    },
    getList() {
      const params = {
        instType: 2,
      }
      this.$http.get(this.$api.common.instSelectCur,params).then((res) => {
        if (res.code == 0) {
          this.dataList = res.data
        }
      })
    },
    handleChange(v){
       this.$store.dispatch('list/setPlatformNo',{ platformNo:v }).then((res) => {
        //  if(res=='success'){

        //  }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
$headerHeight: 90px;
$footerHeight: 80px;
.web-wrapper {
  width: 1450px;
  height: 100%;
  margin: 0 auto;
}

.web-header-wrapper {
  height: $headerHeight;
  background-color: #fff;
  box-shadow: 0 4px 6px #eee;

  .header-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;

    .logo{
      cursor: pointer;
      h1 {
        font-size: 28px;
        letter-spacing: 2px;
        color: #0c1c23;
      }
    } 
  }
}

.web-footer-wrapper {
  height: $footerHeight;
  background-color: #fff;
  border-top: 1px solid #ddd;

  .copyright {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    color: #666;
  }
}

.web-main-wrapper {
  padding: 10px 0;

  .web-wrapper {
    display: flex;
  }
}

.web-context {
  width: 100%;
  min-height: calc(100vh - 20px - #{$headerHeight} - #{$footerHeight});
  background-color: #fff;
  padding: 20px;
}
.right {
  display: flex;
  align-items: center;
  justify-content: center;
  .go-home{
    margin-right: 15px;
    cursor: pointer;
    &:hover{
      border-bottom: 1px solid #0c1c23;
    }
  }
}
</style>
